import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "toastr/build/toastr.min.css";
import toastr from "toastr";
import "./ChatUserModal.css";
import HashLoader from "react-spinners/HashLoader";
import { getColorFromName } from "../../utils/getColor";
import { useDispatch } from "react-redux";

import { doc, setDoc, serverTimestamp, updateDoc } from "firebase/firestore";

import { firestore } from "../../firebase";
import { Trash2Icon } from "lucide-react";
const headers = ["USER", "REACTION", "ACTION"];

const ReactionsModal = ({ isOpen, onClose, currentMessage, activeChat }) => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails")) || {};
  const [loading, setLoading] = useState(true);
  const [filteredUsers, setFilteredUsers] = useState();

  useEffect(() => {
    if (currentMessage?.reactions) {
      setFilteredUsers(currentMessage.reactions);
    }
    setLoading(false);
  }, [isOpen, currentMessage]);

  const handleDeleteReaction = async (userId, emoji) => {
    try {
      const updatedReactions = filteredUsers.filter(
        (reaction) => !(reaction.userId === userId && reaction.emoji === emoji)
      );

      const messageRef = doc(
        firestore,
        `group/${activeChat?._id}/messages/${currentMessage?.id}`
      );
      await updateDoc(messageRef, { reactions: updatedReactions });

      setFilteredUsers(updatedReactions);

      toastr.success("Reaction removed successfully!");
    } catch (error) {
      toastr.error("Failed to remove reaction. Please try again.");
      console.error("Error updating reactions:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered size="xs" className="w-100">
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title>User Reactions</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="members-data-table">
          <div className="members-data-table__table">
            {!loading ? (
              <>
                <div className="members-data-table__header">
                  {headers.map((header) => (
                    <div className="data-table__header-cell" key={header}>
                      <div style={{ display: "flex" }}>
                        <span className="header-text-label">{header}</span>
                      </div>
                    </div>
                  ))}
                </div>

                {filteredUsers && filteredUsers.length > 0 ? (
                  filteredUsers.map((user, index) => (
                    <div className="members-data-table__body" key={index}>
                      <div
                        className={`members-data-table__row-${
                          index % 2 === 0 ? "odd" : "even"
                        }`}
                      >
                        <div className="member-data-table__cell--name">
                          <div className="data-table__cell-body">
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <div
                                className="member-avatar"
                                style={{
                                  backgroundColor: getColorFromName(user.name),
                                }}
                              >
                                <div className="member-avatar__text">
                                  {user.name.substring(0, 1)}
                                </div>
                              </div>
                              <span style={{ marginLeft: "1rem" }}>
                                {user.name}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="member-data-table__cell--email">
                          <div className="member-data-table__cell-body" style={{display: 'flex', justifyContent: 'center'}}>
                            <div className="member__email">{user?.emoji}</div>
                          </div>
                        </div>
                        <div className="member-data-table__cell--actions">
                          <div className="member-data-table__cell-body">
                            {userDetails?._id === user?.userId && (
                              <button
                                className="add__members"
                                onClick={() =>
                                  handleDeleteReaction(
                                    user?.userId,
                                    user?.emoji
                                  )
                                }
                              >
                                <Trash2Icon
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    color: "#d1b794",
                                  }}
                                />
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No Reactions Found</p>
                )}
              </>
            ) : (
              <div className="member-loader">
                <HashLoader color="#d1b794" size={30} />
                <p>Loading Reactions</p>
              </div>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ReactionsModal;
